module.exports = __webpack_public_path__ + "bgColorful.jpg?a5811f24c9f181affe85cab40541b883";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgColorful.jpg
// module id = 50
// module chunks = 0